import Body from "./Body";
import Search from "./Search";

export const Components = {
  Body,
  Search,
};
